import { Button } from 'components';
import { LoginForm } from 'components/Forms/Auth/LoginForm';
import { AuthTemplate } from 'components/templates/AuthTemplate';
import { FC, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useHistory, useParams } from 'react-router-dom';
import {
  loginValidation,
  partnerLoginValidation,
} from 'schemas/authValidation';
import { AuthService } from 'services';
import { ISignIn, TitleByUserRole } from 'types/Auth';

import { yupResolver } from '@hookform/resolvers/yup';
import { useError, useLoader } from 'hooks/utilHooks';
import { TutorPages } from 'pages/Tutor';

export const LoginPage: FC = () => {
  const { loading, showLoader, hideLoader } = useLoader();
  const { error, showError, hideError } = useError();
  const { replace } = useHistory();
  const { userRole } = useParams<{ userRole: ISignIn['role'] }>();

  const form = useForm<ISignIn>({
    defaultValues: {
      password: '',
      cpf: '',
      email: '',
      role: userRole,
      captchaToken: '',
    },
    resolver:
      userRole === 'partner' || userRole === 'company'
        ? // @ts-ignore
          yupResolver(partnerLoginValidation)
        : // @ts-ignore
          yupResolver(loginValidation),
  });

  const title = TitleByUserRole[userRole];
  document.title = title;

  const onSubmit = async (values: ISignIn) => {
    try {
      showLoader();
      hideError();

      await AuthService.login({ ...values, role: userRole });

      switch (userRole) {
        case 'partner':
          replace('/partner/profile');
          break;

        default:
          replace(`/${userRole}/dashboard`);
      }
    } catch (reason) {
      const { message } = reason as Error;
      showError(message);
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    form.reset({
      role: userRole,
      password: '',
      cpf: '',
      email: '',
      captchaToken: '',
    });
  }, [form, userRole]);

  useEffect(() => {
    if (userRole?.toLowerCase()?.startsWith('rep')) {
      replace(`/partner/registration?code=${userRole}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRole]);

  return (
    <form>
      <FormProvider {...form}>
        <AuthTemplate
          title={title}
          error={error}
          loading={loading}
          userRole={userRole}
        >
          <LoginForm>
            <Button
              fullWidth
              type="submit"
              sx={{ mb: 2 }}
              onClick={form.handleSubmit(onSubmit)}
            >
              ENTRAR
            </Button>
          </LoginForm>
        </AuthTemplate>
      </FormProvider>
    </form>
  );
};
